/**
 * Function used as.. for nothing, really (used eg. when some method should be used only on client/server)
 * @returns {void}
 */
export default () => {
	// Do nothing, how easy
};
